/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：442
 */

var r = require(/* 1582 */"./1582")
var o = require(/* 334 */"../../1648/334")
var i = require(/* 1243 */"../1243")
var /* [auto-meaningful-name] */require_300_$$_$$_1648_300_index$f = require(/* 300 */"../../1648/300/index").f
module.exports = function (e) {
  var t = r.Symbol || (r.Symbol = {})
  if (!o(t, e)) {
    require_300_$$_$$_1648_300_index$f(t, e, {
      value: i.f(e)
    })
  }
}
